export const REQUEST_GET_USERS_INBOXES = 'REQUEST_GET_USERS_INBOXES';
export const SET_USERS_INBOXES = 'SET_USERS_INBOXES';
export const REQUEST_GET_MANAGERS_BAWABA = 'REQUEST_GET_MANAGERS_BAWABA';
export const REQUEST_SET_MANAGERS_BAWABA = 'REQUEST_SET_MANAGERS_BAWABA';
export const REQUEST_UPDATE_ASSIGNEMENT_INBOXES =
  'REQUEST_UPDATE_ASSIGNEMENT_INBOXES';
export const REQUEST_COUNT_INBOXES = 'REQUEST_COUNT_INBOXES';
export const SET_COUNT_INBOXES = 'SET_COUNT_INBOXES';

export const INBOXES_TYPES = {
  OPENING: 'OPENING',
  TRANSACTION: 'TRANSACTION',
  JUDICIARY: 'JUDICIARY',
};
